import { cn } from '@/lib/utils';

export function ScoreBadge({ score, label, size = 'md' }: { score: number; label?: string; size?: 'md' | 'lg' }) {
  const tier =
    score >= 85 ? 'great' :
    score >= 70 ? 'good' :
    score >= 50 ? 'fair' :
    'poor';
  const colors: Record<typeof tier, string> = {
    great: 'bg-emerald-500/15 text-emerald-300 ring-emerald-500/40',
    good: 'bg-[var(--color-primary)]/15 text-[var(--color-primary)] ring-[var(--color-primary)]/40',
    fair: 'bg-amber-500/15 text-amber-300 ring-amber-500/40',
    poor: 'bg-rose-500/15 text-rose-300 ring-rose-500/40',
  };
  return (
    <div
      className={cn(
        'inline-flex flex-col items-center justify-center rounded-2xl px-6 py-4 ring-1',
        colors[tier],
        size === 'lg' && 'px-10 py-6',
      )}
    >
      <span className={cn('font-mono font-semibold leading-none', size === 'lg' ? 'text-6xl' : 'text-4xl')}>
        {score}
      </span>
      <span className="mt-1 text-xs uppercase tracking-wider opacity-70">{label ?? '/ 100'}</span>
    </div>
  );
}
